import { render, staticRenderFns } from "./OutreachList.vue?vue&type=template&id=236b37e8&scoped=true&"
import script from "./OutreachList.vue?vue&type=script&lang=js&"
export * from "./OutreachList.vue?vue&type=script&lang=js&"
import style0 from "./OutreachList.vue?vue&type=style&index=0&id=236b37e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236b37e8",
  null
  
)

export default component.exports